import { render, staticRenderFns } from "./UserRecommendations.vue?vue&type=template&id=0f299811&scoped=true&"
import script from "./UserRecommendations.vue?vue&type=script&lang=js&"
export * from "./UserRecommendations.vue?vue&type=script&lang=js&"
import style0 from "./UserRecommendations.vue?vue&type=style&index=0&id=0f299811&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f299811",
  null
  
)

export default component.exports